import React from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

interface SystemBadgesProps {
  systemNames: string[]
  systemLogos: string[]
  showAll?: boolean
  toggleShow?: () => void
}

export const SystemBadges: React.FC<SystemBadgesProps> = ({
  systemNames,
  systemLogos,
  showAll = false,
  toggleShow,
}) => {
  if (!systemNames || systemNames.length === 0 || !systemLogos || systemLogos.length === 0) {
    return <span>--</span>
  }

  return (
    <>
    <div className='d-flex align-items-center'>
      <span className='badge px-3 rounded-pill me-1' style={{border: '1px solid #E1E1E1'}}>
        <img
          src={systemLogos[0]}
          alt={`${systemNames[0]} logo`}
          style={{width: '14px', height: '14px', marginRight: '8px'}}
        />
        <span className='fw-semibold fs-7'>{systemNames[0].trim()}</span>
      </span>

      {systemNames.length > 1 && !showAll && (
        <OverlayTrigger
          placement='right'
          popperConfig={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 8],
                },
              },
            ],
          }}
          overlay={
            <Tooltip id='tooltip-systems' style={{whiteSpace: 'pre-line', textAlign: 'left'}}>
              <div style={{fontSize: '12px', textAlign: 'left'}} className='fw-semibold'>
                {systemNames.slice(1).map((system, idx) => (
                  <div key={idx} className='d-flex align-items-center mb-1'>
                    <img
                      src={systemLogos[idx + 1]}
                      alt={`${system} logo`}
                      style={{width: '16px', height: '16px', marginRight: '8px'}}
                    />
                    <span>{system.trim()}</span>
                  </div>
                ))}
              </div>
            </Tooltip>
          }
        >
          <button className='btn btn-icon btn-sm'>
            <span className='badge px-3 rounded-pill fs-7 py-1.9' style={{border: '1px solid #E1E1E1'}}>
              +{systemNames.length - 1}
            </span>
          </button>
        </OverlayTrigger>
      )}
        </div>
    </>
  )
}
